import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
function t(t) {
  return t && t.release && "function" == typeof t.release;
}

function i(t) {
  return t && t.acquire && "function" == typeof t.acquire;
}

var e = /*#__PURE__*/function () {
  function e(t, i, _e) {
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

    _classCallCheck(this, e);

    if (this.ctor = t, this.acquireFunction = i, this.releaseFunction = _e, this.allocationSize = o, this._pool = new Array(s), this._initialSize = s, this.ctor) for (var n = 0; n < s; n++) {
      this._pool[n] = new this.ctor();
    }
    this.allocationSize = Math.max(o, 1);
  }

  _createClass(e, [{
    key: "destroy",
    value: function destroy() {
      this.prune(0);
    }
  }, {
    key: "acquire",
    value: function acquire() {
      var _o;

      var o;
      if (e.test.disabled) o = new this.ctor();else {
        if (0 === this._pool.length) {
          var _t = this.allocationSize;

          for (var _i = 0; _i < _t; _i++) {
            this._pool[_i] = new this.ctor();
          }
        }

        o = this._pool.pop();
      }

      for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
        t[_key] = arguments[_key];
      }

      return this.acquireFunction ? this.acquireFunction.apply(this, [o].concat(t)) : i(o) && (_o = o).acquire.apply(_o, t), o;
    }
  }, {
    key: "release",
    value: function release(i) {
      i && !e.test.disabled && (this.releaseFunction ? this.releaseFunction(i) : t(i) && i.release(), this._pool.push(i));
    }
  }, {
    key: "prune",
    value: function prune() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._initialSize;

      if (!(t >= this._pool.length)) {
        for (var _i2 = t; _i2 < this._pool.length; ++_i2) {
          var _t2 = this._pool[_i2];

          this._dispose(_t2);
        }

        this._pool.length = t;
      }
    }
  }, {
    key: "_dispose",
    value: function _dispose(t) {
      t.dispose && "function" == typeof t.dispose && t.dispose();
    }
  }]);

  return e;
}();

e.test = {
  disabled: !1
};
export { e as default };